import React, { useEffect, useState } from "react";
import MyOutfitListView from "presentational/portfolio/MyOutfitListView";
import GenderFillModalView from "presentational/common/GenderFillModal/GenderFillModalView";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";

function MyOutfitList(props) {
  const {
    isLoading,
    isEnd,
    outfitList,
    myGenderFilled,
    MyOutfitActions,
    UserProfileActions,
    AppErrorActions,
    getIdTokenWT
  } = props;

  const [needGenderFillModal, setNeedGenderFillModal] = useState(false);

  useEffect(() => {
    initMyOutfit();
  }, []);
  useEffect(() => {
    checkNeedGenderInput();
  }, [myGenderFilled, outfitList]);

  const initMyOutfit = async () => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await MyOutfitActions.initList(idToken);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const submitGenderInfo = async selectedGender => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await UserProfileActions.registerMyGender({ selectedGender, idToken });
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const checkNeedGenderInput = () => {
    if (outfitList.length > 0 && myGenderFilled === "genderUnset") {
      setNeedGenderFillModal(true);
    }
  };

  const handleSubmit = async selectedGender => {
    await submitGenderInfo(selectedGender);
    await setNeedGenderFillModal(false);
  };

  const getMyOutfitList = async () => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await MyOutfitActions.getList(idToken);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  return (
    <div>
      <MyOutfitListView
        list={outfitList}
        isLoading={isLoading}
        isEnd={isEnd}
        callNextListFn={getMyOutfitList}
      />
      <GenderFillModalView
        needGenderFillModal={needGenderFillModal}
        onSubmit={handleSubmit}
      />
    </div>
  );
}

export default withToken(
  withStore({
    stateMap: {
      myOutfit: ["outfitList", "isLoading", "isEnd"],
      userProfile: ["myGenderFilled"]
    },
    dispatchMap: ["myOutfit", "userProfile", "appError"]
  })(MyOutfitList)
);
